import styled from '@emotion/styled';

import { ProjectEligibilityModal } from '@neo.tax/shared';

// Setting overflow to visible to allow the select to overflow the modal
export const StyledProjectEligibilityModal = styled(ProjectEligibilityModal)({
  overflow: 'visible',
});
